import { makeStyles } from 'tss-react/mui';
import GroupJoinButton from '../groups/join-button';
import { useAppContext } from '../../contexts/app';
import { eventPath } from '../../utils/slugify';
import type { Event } from '../../types/Event';
import type { EventInvite } from '../../types/Invite';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    margin: theme.spacing(1, 0),
    '& > p': {
      margin: theme.spacing(1, 0)
    }
  }
}));

type Props = {
  event?: Event;
  eventInvite?: EventInvite;
  autoRsvp?: string;
  onJoin?: (...args: unknown[]) => void;
};

const JoinToggleMessage = ({ event, eventInvite, autoRsvp, onJoin }: Props) => {
  const { isLoggedIn } = useAppContext();
  const { classes } = useStyles();

  if (event.permissions.joinable && isLoggedIn) {
    return null;
  }

  // build returnTo
  let returnTo;
  if (!isLoggedIn) {
    const queryParams = [];
    if (autoRsvp) {
      queryParams.push(`rsvp=${autoRsvp}`);
    }
    if (eventInvite) {
      queryParams.push(`join=${eventInvite.id}`);
    }

    const query = queryParams.length ? `?${queryParams.join('&')}` : '';
    returnTo = `${eventPath(event.id, event.name)}${query}`;
  }

  if (!eventInvite) {
    if (event.group && event.visibility !== 'PUBLIC') {
      return (
        <div className={classes.wrapper}>
          <p>Group membership required to RSVP</p>
          <GroupJoinButton
            group={event.group}
            onJoin={onJoin}
            returnTo={returnTo}
          />
        </div>
      );
    }
  }

  return null;
};

export default JoinToggleMessage;
